import { get } from 'lodash';
import Schema from '../../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import { addIndexesToPath } from '../../../../../utils/helper';
import { APIS } from '../../../../../lib/constants/apis';
const P = Schema.attributes;

type Dependencies = {
	files: any[];
	relations: any[];
};
const ZuwendungsantragDependencies = (application: any) => {
	let dependencies: Dependencies = {
		files: [],
		relations: [],
	};
	const partner = get(application, P.Partner.path, []);
	for (let i = 0; i < partner.length; i++) {
		dependencies.relations.push({
			field: addIndexesToPath(P.Partner.schema.attributes.Unternehmen.path, [`${i}`], ['Partner']),
			api: APIS.Organisation,
		});
	}

	console.log(' zuwendungs antrag dependencies ', dependencies);
	return dependencies;
};
export { ZuwendungsantragDependencies };
